import React, { Component } from "react";
import { profileState } from "../../services/user";
import appContext from "../../contexts/AppContext";
export class CollapseMenu extends Component {
    state = {
        menuId: "1"
    };
    toggleMenus = menuId => {
        this.setState({ menuId: menuId });
    };
    state = {
        profileState: {}
    };

    componentDidMount() {
        profileState()
            .then(response => {
                this.setState({
                    profileState: response.data
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    render() {
        return (
            <div className="card">
                <div className="card-header">
                    <h4 className="my-3 pro-progress-title">
                        <div>
                            Become{" "}
                            <span className="text-success">ProWriter</span>
                            <br />
                            <br />
                            <span className="text-muted">
                                Complete all steps below to become an approved
                                ProWriter and qualify for a ProWriter Plus
                                membership.
                            </span>
                        </div>
                    </h4>
                </div>
                <div className="page-content">
                    <div>
                        <div
                            className="wizard-form"
                            style={{ marginTop: "-10px" }}
                        >
                            <div className="wizard-header">
                                <section className="pro-progress-conditions">
                                    <div
                                        className="accordion"
                                        id="accordionExample"
                                    >
                                        <div
                                            className="card"
                                            style={{ margin: 0 }}
                                        >
                                            <div
                                                className="card-header"
                                                id="headingOne"
                                            >
                                                <h6 className="my-3 pro-progress-title">
                                                    <a
                                                        className="btn btn-link collapsed"
                                                        type="button"
                                                        data-toggle="collapse"
                                                        onClick={() =>
                                                            this.toggleMenus(
                                                                "1"
                                                            )
                                                        }
                                                        data-target="#collapseOne"
                                                        aria-expanded="false"
                                                        aria-controls="collapseTwo"
                                                    >
                                                        <div className="text-secondary">
                                                            1) Verify your
                                                            Identity
                                                        </div>
                                                    </a>
                                                </h6>
                                            </div>

                                            <div
                                                id="collapseOne"
                                                className={
                                                    this.state.menuId === "1"
                                                        ? " fade collapse show"
                                                        : "collapse"
                                                }
                                                aria-labelledby="headingOne"
                                                data-parent="#accordionExample"
                                            >
                                                <div className="card-body">
                                                    <section>
                                                        <div className="inner">
                                                            <div className="form-row">
                                                                <div className="form-holder form-holder-2 w-100">
                                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                                        Confirm
                                                                        your
                                                                        email
                                                                        address
                                                                        {this
                                                                            .state
                                                                            .profileState
                                                                            .email_confirmation ===
                                                                        true ? (
                                                                            <span className="badge badge-success">
                                                                                ✓
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-warning">
                                                                                X
                                                                            </span>
                                                                        )}
                                                                    </li>

                                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                                        Add a
                                                                        profile
                                                                        picture
                                                                        {this
                                                                            .state
                                                                            .profileState
                                                                            .image ===
                                                                        true ? (
                                                                            <span className="badge badge-success">
                                                                                ✓
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge badge-warning">
                                                                                X
                                                                            </span>
                                                                        )}
                                                                    </li>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="card"
                                            style={{ margin: 0 }}
                                        >
                                            <div
                                                className="card-header"
                                                id="headingTwo"
                                            >
                                                <h6 className="my-3 pro-progress-title">
                                                    <a
                                                        className="btn btn-link collapsed"
                                                        type="button"
                                                        data-toggle="collapse"
                                                        onClick={() =>
                                                            this.toggleMenus(
                                                                "2"
                                                            )
                                                        }
                                                        data-target="#collapseTwo"
                                                        aria-expanded="false"
                                                        aria-controls="collapseTwo"
                                                    >
                                                        <div className="text-secondary">
                                                            2) Complete 100% of
                                                            your Writer
                                                            Portfolio
                                                        </div>
                                                    </a>
                                                </h6>
                                            </div>

                                            <div
                                                id="collapseTwo"
                                                className={
                                                    this.state.menuId === "2"
                                                        ? " fade collapse show"
                                                        : "collapse"
                                                }
                                                aria-labelledby="headingTwo"
                                                data-parent="#accordionExample"
                                            >
                                                <div className="card-body">
                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Add your location
                                                        {this.state.profileState
                                                            .location ===
                                                        true ? (
                                                            <span className="badge badge-success">
                                                                ✓
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-warning">
                                                                X
                                                            </span>
                                                        )}
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Add your byline
                                                        {this.state.profileState
                                                            .byline === true ? (
                                                            <span className="badge badge-success">
                                                                ✓
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-warning">
                                                                X
                                                            </span>
                                                        )}
                                                    </li>

                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Add content role(s)
                                                        <span className="badge badge-success">
                                                            ✓
                                                        </span>
                                                    </li>

                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Add topic(s) of interest
                                                        <span className="badge badge-success">
                                                            ✓
                                                        </span>
                                                    </li>

                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Add at least 9 article
                                                        clips
                                                        {this.state.profileState
                                                            .articlesPercentage ===
                                                        true ? (
                                                            <span className="badge badge-success">
                                                                ✓
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-warning">
                                                                X
                                                            </span>
                                                        )}
                                                    </li>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="card"
                                            style={{ margin: 0 }}
                                        >
                                            <div
                                                className="card-header"
                                                id="headingThree"
                                            >
                                                <h6 className="my-3 pro-progress-title">
                                                    <a
                                                        className="btn btn-link collapsed"
                                                        type="button"
                                                        data-toggle="collapse"
                                                        onClick={() =>
                                                            this.toggleMenus(
                                                                "3"
                                                            )
                                                        }
                                                        data-target="#collapseThree"
                                                        aria-expanded="false"
                                                        aria-controls="collapseThree"
                                                    >
                                                        <div className="pro-progress-percentage text-secondary">
                                                            3) Complete and pass
                                                            the English
                                                            competency quiz
                                                        </div>
                                                    </a>
                                                </h6>
                                            </div>

                                            <div
                                                id="collapseThree"
                                                className={
                                                    this.state.menuId === "3"
                                                        ? " fade collapse show"
                                                        : "collapse"
                                                }
                                                aria-labelledby="headingThree"
                                                data-parent="#accordionExample"
                                            >
                                                <div className="card-body">
                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Take English competency
                                                        quiz
                                                        {this.state.profileState
                                                            .quiz === true ? (
                                                            <span className="badge badge-success">
                                                                ✓
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-warning">
                                                                X
                                                            </span>
                                                        )}
                                                    </li>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="card"
                                            style={{ margin: 0 }}
                                        >
                                            <div
                                                className="card-header"
                                                id="headingFour"
                                            >
                                                <h6 className="my-3 pro-progress-title">
                                                    <a
                                                        className="btn btn-link collapsed"
                                                        type="button"
                                                        data-toggle="collapse"
                                                        onClick={() =>
                                                            this.toggleMenus(
                                                                "4"
                                                            )
                                                        }
                                                        data-target="#collapseFour"
                                                        aria-expanded="false"
                                                        aria-controls="collapseFour"
                                                    >
                                                        <div className="pro-progress-percentage text-secondary">
                                                            4) ProWriter
                                                            approves your
                                                            account
                                                        </div>
                                                    </a>
                                                </h6>
                                            </div>

                                            <div
                                                id="collapseFour"
                                                className={
                                                    this.state.menuId === "4"
                                                        ? " fade collapse show"
                                                        : "collapse"
                                                }
                                                aria-labelledby="headingFour"
                                                data-parent="#accordionExample"
                                            >
                                                <div className="card-body">
                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        Your account is under
                                                        review
                                                        {this.state.profileState
                                                            .account_under_review ===
                                                        true ? (
                                                            <span className="badge badge-success">
                                                                ✓
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-warning">
                                                                X
                                                            </span>
                                                        )}
                                                    </li>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
CollapseMenu.contextType = appContext;
export default CollapseMenu;



// WEBPACK FOOTER //
// ./src/components/writer/CollapseMenu.js